import Vue from "vue";
import Vuex from "vuex";

import axios from "axios";
import { jwtDecode } from "jwt-decode";

import nodered from "@/store/modules/nodered.js";
import utils from "@/store/modules/utils.js";
import { log } from "mqtt/dist/mqtt";

Vue.use(Vuex);

const BASE =
  process.env.VUE_APP_LOCAL == "1"
    ? process.env.VUE_APP_LOCAL_BASE_URL
    : `${window.location.protocol}//${window.location.hostname}`;

const PORT =
  process.env.VUE_APP_LOCAL == "1"
    ? process.env.VUE_APP_LOCAL_PORT
    : window.location.protocol.includes("https")
    ? "443"
    : `${process.env.VUE_APP_BACKEND_PORT}`;

const base_url_1 = `${BASE}:${PORT}/api`;
const base_url_2 = `${BASE}:${PORT}/api_analizadores`;

const flask_url = `${process.env.VUE_APP_BACKEND_FLASK_URL}:${process.env.VUE_APP_BACKEND_FLASK_PORT}/flask`;

console.log(base_url_1)

// El token se carga al crear el store: los componentes hijos (p. ej. el menú
// superior) hacen peticiones en su mounted(), antes que el mounted() de App.vue
const decodeToken = (token) => {
  try {
    return token ? jwtDecode(token) : {};
  } catch (e) {
    return {};
  }
};
const savedToken = localStorage.getItem("token") || "";

const store = new Vuex.Store({
  state: {
    abortController: null, // Almacenar el AbortController
    base_url: base_url_1,
    base_analizer_url: base_url_2,
    //base_url: `${process.env.VUE_APP_BACKEND_URL}/api`,
    token: savedToken,
    user: decodeToken(savedToken),

    pages: [],
    originalPages: [],
    selectedPage: 0,
    selectedItem: null,
    selectedItemIndex: 0,
    editing: false,
    showLeftMenu: true,
    //Para poder realizar una copia del elemento seleccionado
    copyedElement: null
  },

  getters: {
    activePages(state) {
      return state.pages.filter((page) => page.active);
    },

    actualPage(state) {
      return state.pages[state.selectedPage];
    },

    userRole(state) {
      return state.user.role_name;
    },

    isLaboratory(state) {
      return state.user.role_name == "laboratory";
    },
    isProduction(state) {
      return state.user.role_name == "produccion";
    },
    isRamos(state) {
      return state.user.role_name == "ramos";
    },

    isAdmin(state) {
      return state.user.is_admin;
    },

    isDeveloper(state) {
      return state.user.is_developer;
    },
    isManteni(state){
      return state.user.role_name == "mantenimiento";
    },
    isProductionN1(state){
      return state.user.role_name == "prodn1";
    },
    isCalidad(state){
      return state.user.role_name == "calidad";
    },
    isUser(state){
      return state.user.role_name == "user";
    }
  },

  mutations: {

    SET_ABORT_CONTROLLER(state, controller) {
      state.abortController = controller;
    },

    setUser(state, payload) {
      state.token = payload;
      state.user = payload ? jwtDecode(payload) : {};
    },

    setEditing(state, value) {
      state.editing = typeof value == "boolean" ? value : !state.editing;
    },

    selectItem(state, { index, item }) {
      state.selectedItemIndex = index;
      state.selectedItem = item.settings.show_in_exec
        ? state.pages[state.selectedPage].item_list[index]
        : state.pages[state.selectedPage].global_item_list[index];
    },

    updateSelectedItem(state, payload) {
      if (state.selectedItem) {
        Object.assign(state.selectedItem, payload);

        if (state.selectedItem.settings.show_in_exec) {
          if (state.selectedItemIndex !== -1)
            Vue.set(state.pages[state.selectedPage].item_list, state.selectedItemIndex, state.selectedItem);
        } else {
          if (state.selectedItemIndex !== -1)
            Vue.set(state.pages[state.selectedPage].global_item_list, state.selectedItemIndex, state.selectedItem);
        }
      }
    },

    deselectItem(state) {
      state.selectedItem = null;
    },

    addItem(state, item) {
      item.settings.show_in_exec
        ? state.pages[state.selectedPage].item_list.push(item)
        : state.pages[state.selectedPage].global_item_list.push(item);
      state.selectedItem = item;
    },

    updateItem(_, { item, pos }) {
      item.customized.width = pos.width;
      item.customized.height = pos.height;
      item.customized.left = pos.left;
      item.customized.top = pos.top;
    },

    toggleLeftMenu(state, value) {
      state.showLeftMenu = value != undefined ? value : !state.showLeftMenu;
    },

    loadPages(state, payload) {
      state.pages = payload;
      state.originalPages = JSON.parse(JSON.stringify(payload));
    },

    setSelectedPage(state, payload) {
      state.selectedPage = payload;
      state.selectedItem = null;
    },

    addPage(state, payload) {
      state.pages.push(payload);
      this.commit("setSelectedPage", state.pages.filter((page) => page.active).length - 1);
    },

    deletePage(state) {
      const indexToChange =
        state.pages
          .filter((page) => page.active)
          .map((e) => e.name)
          .indexOf(state.pages[state.selectedPage].name) - 1 || state.pages.length - 1;
      state.pages[state.selectedPage].active = false;
      this.commit("setSelectedPage", indexToChange);
      return indexToChange;
    },

    changePageName(state, payload) {
      const pagesNames = state.pages.map((page) => (page.active ? page.name : ""));
      if (!pagesNames.includes(payload)) {
        state.pages[state.selectedPage].name = payload;
      } else {
        alert("Existe una página con ese nombre");
      }
    },

    putBackground(state, payload) {
      state.pages[state.selectedPage].background_image = payload;
    },
    copySelectedElement(state){
      state.copyedElement = state.selectedItem;
    },
     
  },

  actions: {
    async getAnalizerData({state,commit}, {path, params}){
      if (state.abortController) {
        console.log("ABORTANDO ANTERIOR!!!")
        state.abortController.abort();
      }
  
      // Crear un nuevo AbortController
      const abortController = new AbortController();
      commit("SET_ABORT_CONTROLLER", abortController);
  

      console.log(path)
      console.log(params)
      const response = await axios.get(`${state.base_analizer_url}/${path}`, {
        headers: { authorization: `Bearer ${state.token}` },
        params,
        signal: abortController.signal, // Asociamos la señal de aborto
      });
      return response.data;
    },

    // Actions for API
    async getData({ state }, { path, params }) {
      const response = await axios.get(`${state.base_url}/${path}`, {
        headers: { authorization: `Bearer ${state.token}` },
        params,
      });
      return response.data;
    },

    async getDataFlask({ state }, path){
      const response = await axios.get(`${flask_url}/${path}`);
      return response;
    },

    async postData({ state }, { path, body }) {
      const response = await axios.post(`${state.base_url}/${path}`, body, {
        headers: { authorization: `Bearer ${state.token}` },
      });
      return response.data.success;
    },

    async postDataWithReturn({ state }, { path, body }) {
      const ruta = `${state.base_url}/${path}`
      console.log(ruta)
      const response = await axios.post(`${state.base_url}/${path}`, body, {
        headers: { authorization: `Bearer ${state.token}` },
      });
      return response.data;
    },

    async putData({ state }, { path, params, body }) {
      const response = await axios.put(`${state.base_url}/${path}${params ? `/${params}` : ""}`, body, {
        headers: { authorization: `Bearer ${state.token}` },
      });
      return response.data.success;
    },

    async deleteData({ state }, { path, params, body }) {
      const response = await axios.delete(`${state.base_url}/${path}${params ? `/${params}` : ""}`, {
        headers: { authorization: `Bearer ${state.token}` },
      });
      return response.data.success;
    },

    // Actions for token management
    storeUser({ commit }, payload) {
      localStorage.setItem("token", payload);
      commit("setUser", payload);
    },

    retrieveToken({ commit }) {
      const token = localStorage.getItem("token");
      commit("setUser", token);
    },

    logout({ commit }) {
      commit("setUser", "");
      localStorage.removeItem("token");
    },

    updateEditing({ commit }, value) {
      commit("setEditing", value);
    },

    selectItem({ commit }, payload) {
      commit("selectItem", payload);
    },

    updateSelectedItem({ commit }, payload) {
      commit("updateSelectedItem", payload);
    },

    deselectItem({ commit }, payload) {
      commit("deselectItem", payload);
    },

    addItem({ commit }, payload) {
      const item = JSON.parse(JSON.stringify(payload));
      commit("addItem", item);
    },

    updateItem({ commit }, { item, rect }) {
      const pos = {
        width: rect.width,
        left: rect.left,
        height: rect.height,
        top: rect.top,
      };
      commit("updateItem", { item, pos });
    },

    changeShowLeftMenu({ commit }) {
      commit("toggleLeftMenu");
    },

    async loadPages({ commit }) {
      const pages = await this.dispatch("getData", { path: "pages" });
      commit("loadPages", pages);
    },

    addPage({ commit }, payload) {
      commit("addPage", payload);
    },

    setSelectedPage({ commit }, payload) {
      commit("setSelectedPage", payload);
    },

    setSelectedPageToHome({ state, commit }) {
      const activePage = state?.pages?.findIndex((e) => e.main == true && e.active == true);
      commit("setSelectedPage", activePage > 0 ? activePage : 0);
    },

    setSelectedPageToBack({ state, commit }) {
      const activePage = state.selectedPage;
      commit("setSelectedPage", activePage > 0 ? activePage : 0);
    },

    deletePage({ commit }) {
      commit("deletePage");
    },

    changePageName({ commit }, payload) {
      commit("changePageName", payload);
    },

    putBackground({ commit }, payload) {
      commit("putBackground", payload);
    },

    copySelectedElement({commit}){
      commit("copySelectedElement");
    },
    pasteSelectedElement({commit, dispatch, state}){
      dispatch('addItem',state.copyedElement);
    }
  },

  modules: { nodered, utils },
});

// Sesión deslizante: si el backend devuelve un token renovado se guarda, para que
// la sesión no caduque mientras la aplicación se siga usando
axios.interceptors.response.use((response) => {
  const renewedToken = response.headers["x-renewed-token"];
  if (renewedToken) store.dispatch("storeUser", renewedToken);
  return response;
});

export default store;
